module.exports = __webpack_public_path__ + "img/pharmacie.f3806565.png";